import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import Media from './Media'
import DropdownOpenTray from './DropdownOpenTray'
import { UI } from '../config'
import '../styles/BrandPillFilter.scss'

export default class BrandPillFilter extends Component {
  static propTypes = {
    brands: PropTypes.arrayOf(PropTypes.string).isRequired,
    currentBrand: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    label: PropTypes.string,
    allLabel: PropTypes.string,
  }

  static defaultProps = {
    currentBrand: null,
    label: 'Filter by Brand:',
    allLabel: 'All Brands',
  }

  buildTrayItems() {
    const { brands, currentBrand, onChange, allLabel } = this.props

    return [
      {
        label: allLabel,
        onClick: () => onChange(null),
        isCurrent: !currentBrand,
      },
      ...brands.map(brand => ({
        label: brand,
        onClick: () => onChange(brand),
        isCurrent: currentBrand === brand,
      })),
    ]
  }

  renderDesktopPills() {
    const { brands, currentBrand, onChange, allLabel } = this.props

    return (
      <>
        <button
          type="button"
          className={classNames('BrandPillFilter-pill', !currentBrand && 'is-active')}
          onClick={() => onChange(null)}
        >
          <span>{allLabel}</span>
        </button>
        {brands.map(brand => (
          <button
            key={brand}
            type="button"
            className={classNames('BrandPillFilter-pill', currentBrand === brand && 'is-active')}
            onClick={() => onChange(brand)}
          >
            <span>{brand}</span>
          </button>
        ))}
      </>
    )
  }

  render() {
    const { brands, currentBrand, label, allLabel } = this.props

    if (!brands.length) return null

    const activeLabel = currentBrand || allLabel

    return (
      <div className="BrandPillFilter">
        <span className="BrandPillFilter-label">{label}</span>
        <Media type="desktop">
          {this.renderDesktopPills()}
        </Media>
        <Media type="mobile">
          <DropdownOpenTray
            className="BrandPillFilter-dropdown"
            label={activeLabel}
            items={this.buildTrayItems()}
            trayTitle={UI.MOBILE_BRAND_FILTER_TRAY_TITLE}
            reverseItems={false}
            triggerVariant="pill"
          />
        </Media>
      </div>
    )
  }
}
